export default {"src":"/login-app/[GIT_HASH]/_next/static/media/credits.57c8ca10.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};